var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.priority === 'H')?_c('i',{staticClass:"fas fa-exclamation fa-fw",staticStyle:{"color":"#be3813"}}):_vm._e(),_vm._v(" "),(_vm.priority === 'Z')?_c('i',{staticClass:"fas fa-arrow-alt-down fa-fw",staticStyle:{"color":"#005cbf"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }